import { render } from "./EndChat.vue?vue&type=template&id=085fc045"
import script from "./EndChat.vue?vue&type=script&lang=js"
export * from "./EndChat.vue?vue&type=script&lang=js"

import "./EndChat.vue?vue&type=style&index=0&id=085fc045&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__